(function () {
  var PAGE_SIZE = 250;
  var redirectEntries = [];
  var exactMatchMap = Object.create(null);
  var loadPromise = null;

  function indexEntries(list) {
    for (var i = 0; i < list.length; i++) {
      var entry = list[i];
      if (!entry || typeof entry.url !== 'string' || !Array.isArray(entry.terms)) continue;
      redirectEntries.push(entry);
      for (var j = 0; j < entry.terms.length; j++) {
        var key = String(entry.terms[j]).trim().toLowerCase();
        if (key && !(key in exactMatchMap)) exactMatchMap[key] = entry.url;
      }
    }
  }

  function fetchPage(page) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + '?section_id=redirect-search-data&page=' + page;
    return fetch(url).then(function (response) {
      if (!response.ok) {
        throw new Error('redirect-search-data fetch failed with status ' + response.status + ' for ' + url);
      }
      return response.text();
    }).then(function (text) {
      // The section_id endpoint returns HTML, not raw JSON: Shopify wraps
      // every section's output in <div id="shopify-section-...">...</div>,
      // even when that output is itself a bare JSON array. Pull the array
      // out of the wrapper instead of assuming the body is already JSON.
      var start = text.indexOf('[');
      var end = text.lastIndexOf(']');
      if (start === -1 || end === -1 || end < start) {
        throw new Error('redirect-search-data response had no JSON array for ' + url + ' - body started with: ' + text.slice(0, 200));
      }
      try {
        return JSON.parse(text.slice(start, end + 1));
      } catch (e) {
        throw new Error('redirect-search-data response was not valid JSON for ' + url + ' - body started with: ' + text.slice(0, 200));
      }
    });
  }

  function loadRedirectMap() {
    if (loadPromise) return loadPromise;
    var page = 1;
    function step() {
      return fetchPage(page).then(function (list) {
        if (!Array.isArray(list)) list = [];
        indexEntries(list);
        if (list.length === PAGE_SIZE) {
          page += 1;
          return step();
        }
        return redirectEntries;
      });
    }
    loadPromise = step().catch(function (error) {
      console.error('[redirect-search] failed to load redirect map, will retry on next search:', error);
      // Don't cache a failure forever - let the next submit/focus attempt retry the fetch.
      loadPromise = null;
      throw error;
    });
    return loadPromise;
  }

  function levenshteinDistance(a, b) {
    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;

    var matrix = [];

    for (var i = 0; i <= b.length; i++) {
      matrix[i] = [i];
    }
    for (var j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
    }

    for (var i2 = 1; i2 <= b.length; i2++) {
      for (var j2 = 1; j2 <= a.length; j2++) {
        if (b.charAt(i2 - 1) === a.charAt(j2 - 1)) {
          matrix[i2][j2] = matrix[i2 - 1][j2 - 1];
        } else {
          matrix[i2][j2] = Math.min(
            matrix[i2 - 1][j2 - 1] + 1,
            matrix[i2][j2 - 1] + 1,
            matrix[i2 - 1][j2] + 1
          );
        }
      }
    }

    return matrix[b.length][a.length];
  }

  function calculateSimilarity(str1, str2) {
    var maxLength = Math.max(str1.length, str2.length);
    var distance = levenshteinDistance(str1, str2);
    return (maxLength - distance) / maxLength;
  }

  function findBestMatch(searchTerm) {
    var trimmedQuery = searchTerm.trim().toLowerCase();

    var exactUrl = exactMatchMap[trimmedQuery];
    if (exactUrl) return exactUrl;

    var searchWords = trimmedQuery.split(' ');

    // Plural/singular pass across all terms
    for (var i = 0; i < redirectEntries.length; i++) {
      var redirect = redirectEntries[i];
      for (var t = 0; t < redirect.terms.length; t++) {
        var termLower = String(redirect.terms[t]).toLowerCase();
        var termWords = termLower.split(' ');
        if (termWords.length !== searchWords.length) continue;

        if (searchWords.length === 1) {
          var searchSingular = pluralize.singular(trimmedQuery);
          var searchPlural = pluralize.plural(trimmedQuery);
          var termSingular = pluralize.singular(termLower);
          var termPlural = pluralize.plural(termLower);

          if (searchSingular === termSingular ||
              searchPlural === termPlural ||
              searchSingular === termLower ||
              searchPlural === termLower ||
              trimmedQuery === termSingular ||
              trimmedQuery === termPlural) {
            return redirect.url;
          }
        }
      }
    }

    // Fuzzy matching pass
    for (var i3 = 0; i3 < redirectEntries.length; i3++) {
      var redirect3 = redirectEntries[i3];
      for (var t3 = 0; t3 < redirect3.terms.length; t3++) {
        var termLower3 = String(redirect3.terms[t3]).toLowerCase();
        var termWords3 = termLower3.split(' ');
        if (termWords3.length !== searchWords.length) continue;

        if (searchWords.length === 1) {
          var searchSingular3 = pluralize.singular(trimmedQuery);
          var searchPlural3 = pluralize.plural(trimmedQuery);
          var termSingular3 = pluralize.singular(termLower3);
          var termPlural3 = pluralize.plural(termLower3);

          var similarities = [
            { similarity: calculateSimilarity(trimmedQuery, termLower3) },
            { similarity: calculateSimilarity(trimmedQuery, termSingular3) },
            { similarity: calculateSimilarity(trimmedQuery, termPlural3) },
            { similarity: calculateSimilarity(searchSingular3, termLower3) },
            { similarity: calculateSimilarity(searchPlural3, termLower3) }
          ];
          var bestMatch = similarities.reduce(function (best, current) {
            return current.similarity > best.similarity ? current : best;
          });

          if (bestMatch.similarity > 0.75) {
            return redirect3.url;
          }
        } else {
          var allWordsMatch = true;
          for (var w = 0; w < searchWords.length; w++) {
            var searchWord = searchWords[w];
            var termWord = termWords3[w];

            if (searchWord === termWord) continue;

            var searchSingularW = pluralize.singular(searchWord);
            var searchPluralW = pluralize.plural(searchWord);
            var termSingularW = pluralize.singular(termWord);
            var termPluralW = pluralize.plural(termWord);

            if (searchSingularW === termSingularW ||
                searchPluralW === termPluralW ||
                searchSingularW === termWord ||
                searchPluralW === termWord ||
                searchWord === termSingularW ||
                searchWord === termPluralW) {
              continue;
            }

            var similaritiesW = [
              { similarity: calculateSimilarity(searchWord, termWord) },
              { similarity: calculateSimilarity(searchWord, termSingularW) },
              { similarity: calculateSimilarity(searchWord, termPluralW) },
              { similarity: calculateSimilarity(searchSingularW, termWord) },
              { similarity: calculateSimilarity(searchPluralW, termWord) }
            ];
            var bestMatchW = similaritiesW.reduce(function (best, current) {
              return current.similarity > best.similarity ? current : best;
            });

            if (bestMatchW.similarity > 0.75) continue;

            allWordsMatch = false;
            break;
          }

          if (allWordsMatch) return redirect3.url;
        }
      }
    }

    return null;
  }

  function isSearchForm(form) {
    var searchUrl = (window.theme && window.theme.routes && window.theme.routes.search) || '/search';
    return !!form && form.tagName === 'FORM' && form.getAttribute('action') === searchUrl;
  }

  function resolveAndGo(form, searchQuery) {
    loadRedirectMap().then(function () {
      var redirectUrl = findBestMatch(searchQuery);

      if (redirectUrl && typeof redirectUrl === 'string' && redirectUrl.indexOf('/collections/') === 0) {
        window.location.href = redirectUrl;
      } else {
        // Bypasses the 'submit' event on purpose - avoids re-entering this
        // same delegated handler and preserves the form's own hidden fields
        // (e.g. options[prefix]) instead of rebuilding a bare ?q= request.
        HTMLFormElement.prototype.submit.call(form);
      }
    }).catch(function (error) {
      // Map failed to load (distinct from "loaded fine, no match") - still
      // let the user's search go through instead of leaving submit dead.
      console.error('[redirect-search] map unavailable, falling back to native search:', error);
      HTMLFormElement.prototype.submit.call(form);
    });
  }

  // Delegated on document (capture phase) instead of bound to specific
  // form/input nodes queried once at DOMContentLoaded, so this keeps working
  // regardless of when the search markup actually lands in the DOM.
  document.addEventListener('submit', function (event) {
    if (typeof pluralize === 'undefined') return;
    var form = event.target;
    if (!isSearchForm(form)) return;

    event.preventDefault();

    var searchInput = form.querySelector('input[type="search"]');
    if (!searchInput) return;

    resolveAndGo(form, searchInput.value.trim().toLowerCase());
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (typeof pluralize === 'undefined') return;

    var input = event.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'search') return;

    var form = input.closest('form');
    if (!isSearchForm(form)) return;

    event.preventDefault();
    resolveAndGo(form, input.value.trim().toLowerCase());
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof pluralize === 'undefined') {
      console.error('Pluralize library not loaded');
      return;
    }
    loadRedirectMap();
  });

  // Backup preload: covers a search box that becomes focused/typed-in before
  // DOMContentLoaded has fired, so the map is already loading by submit time.
  document.addEventListener('focus', function (event) {
    var input = event.target;
    if (input && input.tagName === 'INPUT' && input.type === 'search') loadRedirectMap();
  }, true);
})();
